enum ValidationStatus {
  Success = 'SUCCESS',
  Failed = 'FAILED',
  InProgress = 'IN PROGRESS',
}

export default ValidationStatus
